
<div  cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <div style="float: right;" mat-dialog-actions>
      <button mat-raised-button value="Close" class="alert-button" [mat-dialog-close]="false">
        <mat-icon [title]="data.buttonCancel"> close </mat-icon></button>
  </div>
  
  <app-recalculate-queue></app-recalculate-queue>

</div>
